import React from 'react';
import styled from 'styled-components';
import messageConstant from '../../constants/message.constants';
import logo from '../../assets/img/logo_big.png';
import LoginGG from '../../container/login-page/LoginGG';
import { Space } from 'antd';

const LogoContainer = styled.div`
  width: auto;
  width: 29%;
  float: left;
`;

// const Logo = styled.div`
//   background: url(${logo});
//   background-repeat: no-repeat;
//   height: 100px;
//   width: 250px;
// `;

const Logo = styled.img`
  height: 150px;
  // width: 250px;
`;
const ContainerLeft = styled.div`
  flex: 3;
  padding: 22px 20px;
  background-color: #f9f9fa;
  border: none;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
`;
const ErrorMessage = styled.p`
  font-size: 12px;
  color: #dc3545;
  font-style: italic;
  margin: 0;
`;

const showMessage = (msg) => {
  let item;
  if (messageConstant.hasOwnProperty(msg)) {
    item = messageConstant[msg];
  } else {
    item = msg;
  }
  return <ErrorMessage>{item}</ErrorMessage>;
};

const LoginModal = () => {
  return (
    <ContainerLeft>
      <Space direction="horizontal">
        <LogoContainer>
          <Logo src={logo} />

          {/* <MainTitle>Emil Login</MainTitle> */}
        </LogoContainer>
        Bạn có thể đăng nhập bằng tài khoản GMail.
      </Space>

      <LoginGG />
    </ContainerLeft>
  );
};

export default LoginModal;
